import { http } from './http';
import type { ApiSuccess, CameraGroup, PaginatedResult } from './types';

const PATH = '/api/camera-groups';

export interface CameraGroupListQuery {
  search?: string;
  page?: number;
  pageSize?: number;
  sortBy?: 'name' | 'createdAt';
  sortOrder?: 'asc' | 'desc';
}

export interface CameraGroupCreateInput {
  name: string;
  description?: string | null;
}

export type CameraGroupUpdateInput = Partial<CameraGroupCreateInput>;

export const cameraGroupsApi = {
  async list(
    query: CameraGroupListQuery = {},
    signal?: AbortSignal,
  ): Promise<PaginatedResult<CameraGroup>> {
    const res = await http.get<ApiSuccess<PaginatedResult<CameraGroup>>>(PATH, {
      params: query,
      signal,
    });
    return res.data.data;
  },

  async get(id: number, signal?: AbortSignal): Promise<CameraGroup> {
    const res = await http.get<ApiSuccess<CameraGroup>>(`${PATH}/${id}`, { signal });
    return res.data.data;
  },

  async create(input: CameraGroupCreateInput): Promise<CameraGroup> {
    const res = await http.post<ApiSuccess<CameraGroup>>(PATH, stripUndefinedKeys(input));
    return res.data.data;
  },

  async update(id: number, input: CameraGroupUpdateInput): Promise<CameraGroup> {
    const res = await http.put<ApiSuccess<CameraGroup>>(`${PATH}/${id}`, stripUndefinedKeys(input));
    return res.data.data;
  },

  async remove(id: number): Promise<void> {
    await http.delete(`${PATH}/${id}`);
  },
};

function stripUndefinedKeys<T extends object>(obj: T): Partial<T> {
  const out: Partial<T> = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v !== undefined) (out as Record<string, unknown>)[k] = v;
  }
  return out;
}
